import { render, staticRenderFns } from "./AdditionalBudgetOverview.vue?vue&type=template&id=8fe95a90"
import script from "./AdditionalBudgetOverview.vue?vue&type=script&lang=ts"
export * from "./AdditionalBudgetOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports